export const noDeliveryBannerEvent = 'Delivery Unavailable - Banner Shown';
